<template>
  <UButton
      class="p-0 bg-transparent hover:bg-transparent hover:opacity-80 active:bg-transparent focus:outline-none group"
      :class="textClass" @click="showModal = !showModal">
    <UIcon name="ph:magnifying-glass"
           class="w-6 h-6 block group-hover:hidden group-focus:hidden group-active:hidden"/>
    <UIcon name="ph:magnifying-glass-fill"
           class="w-6 h-6 hidden group-hover:block group-focus:block group-active:block"/>
  </UButton>
  <UModal v-model:open="showModal" :ui="{overlay: 'bg-slate-900/70'}">
    <template #content>
      <form @submit.prevent="handleSearch">
        <UInput placeholder="Pesquisar cursos" v-model="search" size="xl" variant="ghost"
                class="block p-4"
                :ui="{base: 'hover:bg-white focus:bg-white'}">
          <template #trailing>
            <UButton variant="ghost" size="xl" icon="ph:magnifying-glass-bold" @click="handleSearch"
                     class="text-primary hover:cursor-pointer hover:bg-primary hover:text-white"/>
          </template>
        </UInput>
      </form>
    </template>
  </UModal>
</template>
<script setup lang="ts">
const props = defineProps<{
  variant: 'primaria' | 'secundaria'
}>()

const showModal = ref<boolean>(false)

const search = ref('')

const isPrimaria = computed(() => props.variant === 'primaria')
// Classe de cor para ícones e separadores
const textClass = computed(() => isPrimaria.value ? 'text-white' : 'text-gray-700')

const handleSearch = () => {
  // Limpa espaços em branco nas pontas
  const termo = search.value.trim()

  // Não navegar se o usuário submeter o formulário vazio
  if (!termo) return

  // Navega para a rota passando o termo como querystring
  navigateTo({
    path: '/categoria/',
    query: {
      search: termo
    }
  })
  showModal.value = false
}
</script>